module.exports = __webpack_public_path__ + "static/img/02.b051231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour1/02.jpg
// module id = 76MK
// module chunks = 0